export type ModuleTestQuestionDraft = {
  correctAnswer: string;
  explanation: string;
  question: string;
  wrongAnswers: string[];
};

export type ModuleTestQuestion = {
  choices: string[];
  correctAnswer: string;
  explanation: string;
  question: string;
};

export type ModuleTestQuestionResult =
  { error: null; questions: ModuleTestQuestion[] } | { error: string; questions: [] };

function normalizedLines(values: string[]): string[] {
  return values.map((value) => value.trim()).filter(Boolean);
}

export function buildModuleTestQuestions(
  drafts: ModuleTestQuestionDraft[],
): ModuleTestQuestionResult {
  const questions: ModuleTestQuestion[] = [];

  for (const [index, draft] of drafts.entries()) {
    const question = draft.question.trim();
    const correctAnswer = draft.correctAnswer.trim();
    const explanation = draft.explanation.trim();
    const wrongAnswers = normalizedLines(draft.wrongAnswers);
    const hasInput = Boolean(question || correctAnswer || explanation || wrongAnswers.length > 0);

    if (!hasInput) continue;

    const questionNo = index + 1;
    if (!question || !correctAnswer || !explanation || wrongAnswers.length === 0) {
      return {
        error: `確認問題${questionNo}は、設問・正解・誤答（1件以上）・解説をすべて入力してください。`,
        questions: [],
      };
    }

    const uniqueWrongAnswers = [...new Set(wrongAnswers)];
    if (uniqueWrongAnswers.includes(correctAnswer)) {
      return {
        error: `確認問題${questionNo}の正解と誤答に同じ内容があります。`,
        questions: [],
      };
    }
    if (uniqueWrongAnswers.length > 5) {
      return {
        error: `確認問題${questionNo}の誤答は5件以内にしてください。`,
        questions: [],
      };
    }

    questions.push({
      choices: [correctAnswer, ...uniqueWrongAnswers],
      correctAnswer,
      explanation,
      question,
    });
  }

  return { error: null, questions };
}
